// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2avVY","label":"styles_label__3quCp"};